export const isValid24HourTime = (input: string) => {
  // Regular expression to match the hh:mm format
  const regex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

  // Use the test() method to check if the input matches the regular expression
  return regex.test(input);
};
